import gql from "graphql-tag";

const GOOGLE_LOGIN_MUTATION = gql`
    mutation googleLogin($googleSignInData: GoogleSignInInput!) {
        googleLogin(googleSignInData: $googleSignInData) {
            accessToken
            refreshToken
            username
            isTwoFaEnabled,
            twoFaToken
            firstname
            surname
        }
    }
`;

export default GOOGLE_LOGIN_MUTATION;